module.exports = __webpack_public_path__ + "img/coupon_bcg.9823d7c2.png";